module.exports = __webpack_public_path__ + "static/media/t-1.d4cf9db6.jpg";